
export const getPlacementType = (placementArr) => {
	const length = placementArr?.length;
	if (length === 2) {
		return placementArr[0].split('_')[1];
	} else if (length === 3) {
		return 'property';
	} else {
		return undefined;
	}
};

export const getAccountPurposeId = (placementArr) => {
	return placementArr[placementArr.length - 1];
};

export const getAccountOwnerId = (placementType, placementArr) => {
	if (placementType === 'portfolio') {
		return placementArr[0].split('_')[0];
	} else if (placementType === 'property') {
		return placementArr[placementArr.length - 2].split('_')[0];
	} else {
		return '';
	}
};

const accountOwnerTypeMap = {
	portfolio: 'SubPortfolio',
	property: 'Property',
};

const accountOwnerAppNameMap = {
	portfolio: 'portfolio',
	property: 'property',
};

export const createMultiPostObject = (placements, selectedRows, source=undefined, sourceId=undefined) => {
	let accountParams = {};
	let indices = [];
	let i = 0;

	for (let key in placements) {
		const placementArr = placements[key];
		const placementType = getPlacementType(placementArr);
		const accountPurposeId = getAccountPurposeId(placementArr);
		const accountOwnerId = getAccountOwnerId(placementType, placementArr);

		let accountSourceId = sourceId ? sourceId : key.substring(10);
		if (!source) source = accountSourceId.substring(0, 2).toUpperCase();

		const selectedRow = selectedRows.find(row => row?.key === accountSourceId);
		const description = selectedRow ? 
			(selectedRow.name?.length ? selectedRow.name : selectedRow.account) : 
			((selectedRows[i].name?.length ? selectedRows[i].name : selectedRows[i].account) || '');
		accountSourceId = accountSourceId.split("_").pop();

		accountParams[`accountPurposeId${i}`] = accountPurposeId;
		accountParams[`description${i}`] = description;
		accountParams[`sourceId${i}`] = accountSourceId;
		accountParams[`source${i}`] = source;
		accountParams[`accountOwnerId${i}`] = accountOwnerId;
		accountParams[`accountOwnerType${i}`] = accountOwnerTypeMap[placementType];
		accountParams[`accountOwnerAppName${i}`] = accountOwnerAppNameMap[placementType];
		indices.push(i);

		i++;
	}

	accountParams['agreement'] = false;
	return accountParams;
};

export const createMultiPostObject2 = (data, source, sourceId) => {
	let accountParams = {};
	Object.keys(data).forEach(i => {
		let tagIds = []
		for (let fullTagId of data[i]['genericTags']) {
			if (fullTagId.startsWith('tag_')) {
				tagIds.push(parseInt(fullTagId.replace('tag_', ''), 10));
			}
		}

		accountParams[`accountPurposeId${i}`] = data[i]['purpose'];
		accountParams[`description${i}`] = data[i]['name'];
		accountParams[`genericTags${i}`] = tagIds;
		accountParams[`sourceId${i}`] = sourceId;
		accountParams[`source${i}`] = source;
	});

	accountParams['agreement'] = false;
	return accountParams;
}
